
import Vue from "vue";
import AppHeader from "@/components/layout/AppHeader.vue";
import AppLoading from "@/components/UI/AppLoading.vue";

export default Vue.extend({
  name: "AppAdminLayout",
  components: {
    AppHeader,
    AppLoading,
  },
});
